
import { defineComponent } from "vue";
import { EventInput } from "Models";

export default defineComponent({
  emits: ["dateChanged", "update:modelValue"],
  props: {
    modelValue: {},
    modelModifiers: {
      default: () => ({}),
    },
    borderClass: Object,
    label: {
      type: String
    },
    placeholder: {
      type: String,
      default: "dd/mm/yyyy",
    },
    inputClass: Object,
    startDate: {
      type: Date,
      default: null,
    },
    endDate: {
      type: Date,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    updateInput($event: EventInput) {
      this.valueChange($event.target.value);
    },
    valueChange(val: string) {
      this.$emit("update:modelValue", val);
    },
    onDateChange(val: Date) {
      this.$emit("dateChanged", val);
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler(val) {
        if (!!val) {
          $((this.$refs as any).dt).datepicker("setStartDate", val);
        }
      },
    },
    endDate: {
      immediate: true,
      handler(val) {
        if (!!val) {
          $((this.$refs as any).dt).datepicker("setEndDate", val);
        }
      },
    },
  },
  mounted() {
    const vm = this;
    $((this.$refs as any).dt)
      .datepicker({
        format: "dd/mm/yyyy",
        language: "vi",
        autoclose: true
      })
      .on('hide', function (e) {
        e.stopPropagation();
      })
      .on("changeDate", function (ev) {
        vm.valueChange($(vm.$refs.dtInput).val() as string);
        vm.onDateChange(new Date(ev.date.valueOf()));
        $(vm.$refs.dt).datepicker("hide");
      });
  },
});
